import { createContext, useContext, useState } from 'react';

const IsgContextDispatch = createContext(null);
const IsgContextState = createContext(null);

function IsgProvider({ children }) {
  const [studentGradebook, setStudentGradebook] = useState({
    categoriesData: [],
    course: {
      courseId: '',
      grade: 0,
      pointsPossible: 0,
      pointsEarned: 0,
    },
  });

  return (
    <IsgContextState.Provider value={studentGradebook}>
      <IsgContextDispatch.Provider value={setStudentGradebook}>
        {children}
      </IsgContextDispatch.Provider>
    </IsgContextState.Provider>
  );
}

const useIsgStore = () => {
  const state = useContext(IsgContextState);
  const dispatch = useContext(IsgContextDispatch);
  if (state === null || dispatch === null) {
    throw new Error('useIsgStore must be used within an IsgProvider');
  }
  return [state, dispatch];
};

export { IsgProvider, useIsgStore };
